/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import '../css/style.scss';
import _ from 'lodash';
import '../css/thankYouCheckIn.scss';
import ThankYouImage from '../../../../../assets/svg/vms/1024x768_checkout_building.svg';
import HomePageLogo from '../../../../../assets/images/vms/bslogo.png';

const Page3 = props => {
  const { firstName, lastName, heroFirstName, translations, setGoTo, config } = props;
  return (
    <>
      <div className="tci-wrap">
        <div className="tci-wrap__left">
          <div className="tci-wrap__left-image">
            <img className="hide__landscape" src={ThankYouImage} alt="thank-you-img" />
          </div>
        </div>
        <div className="tci-wrap__right">
          <div className="tci-wrap__head">
            <div className="tci-wrap__head-logo">
              <img src={HomePageLogo} alt="homepage-logo" />
            </div>
            <div className="tci-wrap__right-image">
              <img className="hide__portrait--thank" src={ThankYouImage} alt="thank-you-img" />
            </div>
          </div>
          <div className="tci-boxes">
            <div className="tci-boxes__row-title">
              {_.replace(_.get(translations, 'thankYou'), ':visitor', _.join([firstName, lastName], ' '))}
            </div>
            <div className="tci-boxes__row-subtitle">
              {_.replace(_.get(translations, 'weHaveSentANotification'), ':host', _.startCase(heroFirstName))}
            </div>
            <div className="tci-boxes__row-description">{_.get(translations, 'dontForgetTo')}</div>

            <button type="button" className="tci-boxes__row-button" onClick={() => setGoTo('next')}>
              {_.get(config, 'page3.btn_next.text', '')}
            </button>
          </div>
        </div>
      </div>
      <div className="ci-footer">{_.get(translations, 'allRightsReserved')}</div>
    </>
  );
};

Page3.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  heroFirstName: PropTypes.string,
  translations: PropTypes.shape(),
  setGoTo: PropTypes.func.isRequired,
  config: PropTypes.shape(),
};

Page3.defaultProps = {
  firstName: '',
  lastName: '',
  heroFirstName: '',
  translations: {},
  config: {},
};

export default Page3;
